import * as theme from "../theme";
import Button from "react-bootstrap/Button";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import CancelIcon from "@material-ui/icons/Cancel";
import _ from "lodash";

import PerfectScrollbar from "react-perfect-scrollbar";
import {
  getUserInformation,
  getUserDetails,
  getUpdateButtonStatus,
  toggleUpdateButton,
  geNewUserModelStatus,
  toggleNewUserModel,
  getUpdateUserModelStatus,
  toggleUpdateUserModel,
  selectUpdateUser,
  getUpdateUserSelected,
  updateDetails,
  addNewUser,
  getAllUsers,
  getAllUsersList,
  getUpdateErrors,
} from "../store/userManagement";
import { toast } from "react-toastify";
import ReactSelect from "react-select";
import {
  getBrokeragesList,
  loadBrokerages,
  brokerageSelected,
} from "../store/brokerages";
import {
  getBrokerageInformation,
  getDetailsAdmin,

} from "../store/brokerage";
import Select from "react-dropdown-select";
import { SdCardSharp } from "@material-ui/icons";
import BmsView from "../components/Admin/BmsView"
import { useNavigate } from "react-router-dom";
import { sendSignupEmail, storeEmailId } from "../store/passwordManagement";

const BrokerageSuperAdminBMS = (props) => {
  const dispatch = useDispatch();
  const information = useSelector(getBrokerageInformation);
  let history = useNavigate();
  const [selectedCode, setSelectedCode] = useState(null);
  const [selectedAddressList, setSelectedAddressList] = useState(null);
  const brokerages = useSelector(getBrokeragesList);
  const [selectedBrokerageName, setSelectedBrokerageName] = useState(
    "Search for a brokerage"
  );
  useEffect(() => {
    dispatch(loadBrokerages());
  }, [dispatch]);


  const onChangeHandle = (value) => {
    if (value[0]?.code) {
      history("/quoteyadmin/bms?c=" + encodeURIComponent(value[0].code));
      dispatch(getUserDetails({ brokerage_code: value[0].code }));
      dispatch(getDetailsAdmin(value[0].code));
      setSelectedCode(value[0].code);
      setSelectedBrokerageName(value[0].name);
      setSelectedAddressList(value[0].address);
    }
  };
  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
        }}
      >
        <div
          style={{
            width: "80%",
            marginLeft: "10%",
            marginTop: "20px",
            marginBottom: "20px",
          }}
        >
          <Select
            placeholder={selectedBrokerageName}
            color={theme.COLORS.primary_navyblue}
            searchable={true}
            onChange={(values) => onChangeHandle(values)}
            values={[]}
            options={brokerages}
            style={{
              width: "100%",
              height: "6vh",
              fontSize: "1.9vmin",
              border: "5px solid white",
              borderRadius: 15,
              fontFamily: "GibsonRegular",
            }}
            labelField={"name"}
            valueField={"code"}
            dropdownHeight={"58vh"}
          />
        </div>
      </div>

      <BmsView
        isQadmin={true}
        brokerageCode={selectedCode}
      />

    </div>
  );
};





export default BrokerageSuperAdminBMS;
